/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Payment_TimingInputs */

const en_reference_field_payment_timing = /** @type {(inputs: Reference_Field_Payment_TimingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment timing`)
};

/**
* | output |
* | --- |
* | "Payment timing" |
*
* @param {Reference_Field_Payment_TimingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_payment_timing = /** @type {((inputs?: Reference_Field_Payment_TimingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Payment_TimingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_payment_timing(inputs)
});